export default "__VITE_ASSET__daf17772__"